(function() {
  const queue = [];
  let flushTimer = null;

  function hasGtag() {
    return typeof window.gtag === 'function';
  }

  function hasDataLayer() {
    return Array.isArray(window.dataLayer);
  }

  function pushDataLayer(payload) {
    if (!hasDataLayer()) return false;
    window.dataLayer.push(Object.assign({}, payload));
    return true;
  }

  function sendGtag(eventName, params) {
    if (!hasGtag()) return false;
    window.gtag('event', eventName, params || {});
    return true;
  }

  function normalizePayload(eventName, params) {
    return {
      event: eventName,
      params: Object.assign({}, params || {})
    };
  }

  function scheduleFlush() {
    if (flushTimer) return;
    flushTimer = window.setInterval(function() {
      if (!hasGtag() && !hasDataLayer()) return;
      flushQueue();
      if (!queue.length) {
        window.clearInterval(flushTimer);
        flushTimer = null;
      }
    }, 500);
    window.setTimeout(function() {
      if (!flushTimer) return;
      window.clearInterval(flushTimer);
      flushTimer = null;
      queue.length = 0;
    }, 10000);
  }

  function flushQueue() {
    if (!queue.length) return;
    while (queue.length) {
      const item = queue.shift();
      sendGtag(item.event, item.params);
      pushDataLayer(Object.assign({ event: item.event }, item.params));
    }
  }

  function track(eventName, params) {
    const payload = normalizePayload(eventName, params);
    const sentViaGtag = sendGtag(payload.event, payload.params);
    const sentViaDataLayer = pushDataLayer(Object.assign({ event: payload.event }, payload.params));

    if (!sentViaGtag && !sentViaDataLayer) {
      queue.push(payload);
      scheduleFlush();
    }
  }

  function trackLead(options) {
    const leadSource = options && options.leadSource ? String(options.leadSource) : 'website';
    const formId = options && options.formId ? String(options.formId) : '';
    const formName = options && options.formName ? String(options.formName) : '';
    const payload = {
      lead_source: leadSource
    };

    if (formId) payload.form_id = formId;
    if (formName) payload.form_name = formName;
    if (options && options.currency) payload.currency = String(options.currency);
    if (options && typeof options.value !== 'undefined' && options.value !== null && options.value !== '') {
      const numericValue = Number(options.value);
      if (Number.isFinite(numericValue)) payload.value = numericValue;
    }

    track('generate_lead', payload);
  }

  function collectMarkerParams(marker) {
    const params = {};
    Object.keys(marker.dataset).forEach(function(key) {
      if (!key.startsWith('swhTrackParam')) return;
      const paramName = key.replace(/^swhTrackParam/, '');
      if (!paramName) return;
      const normalized = paramName.charAt(0).toLowerCase() + paramName.slice(1);
      params[normalized.replace(/[A-Z]/g, function(match) {
        return '_' + match.toLowerCase();
      })] = marker.dataset[key];
    });
    return params;
  }

  function initSuccessMarkers() {
    const navigationEntries = window.performance && typeof window.performance.getEntriesByType === 'function'
      ? window.performance.getEntriesByType('navigation')
      : [];
    const navType = navigationEntries.length ? navigationEntries[0].type : '';
    if (navType === 'reload') return;

    document.querySelectorAll('[data-swh-track-event]').forEach(function(marker) {
      const eventName = marker.dataset.swhTrackEvent;
      if (!eventName) return;

      const onceKey = marker.dataset.swhTrackOnce;
      if (onceKey && window.sessionStorage && window.sessionStorage.getItem(onceKey) === '1') return;

      const params = collectMarkerParams(marker);
      if (eventName === 'generate_lead') {
        trackLead({
          leadSource: params.lead_source || '',
          formId: params.form_id || '',
          formName: params.form_name || '',
          currency: params.currency,
          value: params.value
        });
      } else {
        track(eventName, params);
      }

      if (onceKey && window.sessionStorage) {
        window.sessionStorage.setItem(onceKey, '1');
      }
    });
  }

  window.SWHAnalytics = {
    track: track,
    trackLead: trackLead,
    flushQueue: flushQueue
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSuccessMarkers, { once: true });
  } else {
    initSuccessMarkers();
  }
})();
